import styled from 'styled-components';

export const SectionTitleV2 = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  font-weight: 700;
  font-size: 24px;
  margin-bottom: 20px;
  color: #18233A;
  letter-spacing: -0.3px;

  svg {
    color: #18233A;
    width: 22px;
    height: 22px;
  }
`;